import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useAuth } from '@auth';
import { routes } from '@/shared/routes';
import { clearDataLayerUser } from '@/shared/analytics';
import Logo from './Logo';

export default function DashboardNav() {
  const { user } = useAuth();

  return (
    <header className="sticky top-0 z-20 border-b border-slate-200/70 bg-white/95">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="h-full w-full bg-[radial-gradient(circle_at_top,_#eff6ff_0%,_#ffffff_45%,_#ecfdf5_100%)] opacity-80" />
      </div>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-4 py-4">
          <Logo />
          <div className="flex flex-shrink-0 items-center gap-3">
            <span className="hidden items-center rounded-full border border-slate-200/70 bg-white/70 px-4 py-2 text-xs font-semibold text-slate-600 shadow-sm sm:inline-flex">
              {user?.email}
            </span>
            <Link
              to={routes.app.settings}
              className="inline-flex items-center gap-2 rounded-full border border-slate-200/70 bg-white/70 px-4 py-2 text-xs font-semibold text-slate-600 shadow-sm transition hover:-translate-y-0.5 hover:bg-white"
            >
              <FormattedMessage id="nav.settings" />
            </Link>
            <a
              href={routes.auth.signOut}
              onClick={clearDataLayerUser}
              className="inline-flex items-center gap-2 rounded-full bg-brand-900 px-4 py-2 text-xs font-semibold text-white shadow-lg shadow-brand-900/20 transition hover:-translate-y-0.5 hover:bg-brand-800"
            >
              <FormattedMessage id="nav.signOut" />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
}
